import { IsNever, SchemaTypeName } from '../../../primitives';
import { ISchemaInput, NestedSchema, RootSchema } from '../../../union';
import { ISchemaArray, ISchemaArrayContent } from './array.types';

export * from './array.types';

/**
 * Property value is an array
 * - Can't yet support `enum` or `const`: typing is at least difficult, perhaps impossible
 */
export function array<ItemType extends ISchemaArrayContent>(
    schema: RootSchema<ISchemaInput<ISchemaArray<ItemType>>>
): RootSchema<ISchemaArray<ItemType>>;
export function array<ItemType extends ISchemaArrayContent>(
    schema: NestedSchema<ISchemaInput<ISchemaArray<ItemType>>>
): NestedSchema<ISchemaArray<ItemType>>;
export function array<ItemType extends ISchemaArrayContent>(
    schema: ISchemaInput<ISchemaArray<ItemType>>
): ISchemaArray<ItemType> {
    return {
        type: SchemaTypeName.array,
        ...schema,
    };
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = array({ description: '', $id: 'hello', title: '', items: {} as any }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = array({ description: '', items: {} as any }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
